module.exports = __webpack_public_path__ + "img/magic-bus-company.f16c6334.webp";